import { Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const InvestmentApproach = () => {
  const { t } = useLang();
  return (
    <section
      id="investment-approach"
      data-testid="investment-approach-section"
      className="scroll-mt-24 bg-[#F4F3EF] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-6">
            {t.approach.overline}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl leading-tight tracking-tight text-[#1A1C19] max-w-2xl">
            {t.approach.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-x-16 gap-y-12">
          {t.approach.principles.map((p, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div
                data-testid={`principle-${i}`}
                className="border-t border-stone-300 pt-6"
              >
                <div className="flex items-baseline gap-4">
                  <span className="font-serif text-[#B5A68B] text-lg">
                    0{i + 1}
                  </span>
                  <h3 className="font-serif text-2xl md:text-3xl text-[#1A1C19]">
                    {p.title}
                  </h3>
                </div>
                <p className="mt-4 text-base md:text-lg leading-relaxed text-[#5C5C59] max-w-xl">
                  {p.copy}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-24" data-testid="process-timeline">
            <p className="text-xs md:text-sm font-medium tracking-[0.3em] uppercase text-[#5C5C59] mb-10">
              {t.approach.processLabel}
            </p>
            <ol className="relative grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-y-10">
              <span className="hidden lg:block absolute top-[13px] left-[8%] right-[8%] h-px bg-stone-300" />
              {t.approach.steps.map((step, i) => (
                <li
                  key={i}
                  data-testid={`timeline-step-${i}`}
                  className="relative flex flex-col items-center text-center px-2"
                >
                  <span className="relative z-10 flex h-7 w-7 items-center justify-center rounded-full border border-[#1A1C19] bg-[#F4F3EF] text-xs font-semibold text-[#1A1C19]">
                    {i + 1}
                  </span>
                  <span className="mt-4 text-sm md:text-base font-medium text-[#1A1C19]">
                    {step}
                  </span>
                </li>
              ))}
            </ol>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
